import React from 'react'

// แสดง TDS code ตัวหนาสีเขียว และ version อยู่ด้านล่าง ใช้ร่วมกันทุกตารางรายการเอกสาร
const TdsCodeCell = ({ tdscode, revision }) => (
    <div style={{ padding: '6px 0' }}>
        <div style={{ fontWeight: 700, color: '#1a7f5a', whiteSpace: 'nowrap' }}>{tdscode}</div>
        <span style={{ fontSize: 11, color: '#6c757d' }}>V.{revision}</span>
    </div>
)

export default TdsCodeCell
